/************************************** THIRD-PARTY MODULES ***************************************/
import React from 'react';
import cn from 'classnames';
import {throttle} from 'mad-utils/lib/shared';

/**************************************** PROJECT MODULES *****************************************/
import {CITextLink, SubmitButton, translate} from '@canimmunize/core-imports';

/********************************************* EXPORT *********************************************/
/**
 * Standard warning modal content
 * Wrap with a CIModal to display
 *
 * Note that if a close button is desired, xButtonProps will have to be set on
 * CIModal to display it correctly
 */
export const WarningModalContent = (props: {
    handleCancel: EventHandler;
    handleSubmit: EventHandler;
    mainText: string;
    modalTitle?: string;
    okayBtnText?: string;
    okayBtnId?: string;
    cancelBtnText?: string;
    cancelBtnId?: string;
    contentWrapperStyle?: React.CSSProperties;
}) => {
    const cancelBtnId = props.cancelBtnId || props.cancelBtnText || `warning-modal-cancel-button`;
    const okayBtnId = props.okayBtnId || props.okayBtnText || `warning-modal-okay-button`;
    return (
        <div className={cn(`flex row center`)}>
            <div
                className={cn(`ci-modal-base-width`, `p-25`, `br-4`, `bg-white`)}
                style={props.contentWrapperStyle || {}}
            >
                <div className={cn(`flex space-between`)} style={{position: `sticky`}}>
                    <h1 className={cn(`mt-0`)} tabIndex={0}>
                        {props.modalTitle || translate(`warning`).cap1LowerRest()}
                    </h1>
                </div>
                <div className={cn(`flex col`)}>
                    <p>{props.mainText}</p>
                </div>
                <div className={cn(`flex end ai-center`)}>
                    <CITextLink
                        id={cancelBtnId}
                        key="anv_cancel_button"
                        mergeClasses={cn(`ml-20`)}
                        onClick={props.handleCancel}
                    >
                        {props.cancelBtnText || translate(`cancel`).capitalize}
                    </CITextLink>
                    <SubmitButton
                        id={okayBtnId}
                        labelId={`unreceive`}
                        onClick={throttle(props.handleSubmit, 2000)}
                        isLoading={false}
                        ariaLabel={translate(`okay`).capitalize}
                        tabIndex={0}
                        width={100}
                        height={30}
                        bgColor={`bg-ci-red`}
                        mergeClasses={cn(`mr-7 ml-20 pr-15 pl-15`, `helvetica-neue`)}
                    >
                        {props.okayBtnText || translate(`okay`).capitalize}
                    </SubmitButton>
                </div>
            </div>
        </div>
    );
};

WarningModalContent.displayName = `WarningModalContent`;
